<template>
  <v-hover
    v-model="hover"
    @click.native="click()"
    :disabled="loading"
    v-ripple="loading ? false : { center: true }"
  >
    <v-card :class="['card_border', onHover ? 'card_hover' : '']" :elevation="onHover ? 4 : 0">
      <v-container class="text-center font-weight-bold">
        <v-row>
          <v-col>
            <v-progress-circular v-if="loading" indeterminate :width="3" />
            <slot v-else v-bind:textColor="textColor"></slot>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
  export default {
    name: "BigButton",
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        hover: false,
      };
    },
    computed: {
      textColor() {
        if (this.onHover) {
          return "primary lighten-1";
        }
        return "secondary1";
      },
      onHover() {
        return this.hover && !this.loading;
      },
    },
    methods: {
      click() {
        if (this.loading) {
          return;
        }

        this.$emit("click");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card_border {
    border: 1px solid var(--v-secondary1-base);
    color: var(--v-secondary1-base);
    user-select: none;
  }

  .card_hover {
    cursor: pointer;
    color: var(--v-primary-lighten1);
    background-color: #f6f7fb;
  }
</style>
